import staticConfig from '@config/static-config';
import { UnsupportedError } from '@errors';
import {
  CosmosChain,
  CosmosChainInfo,
  CosmosHubChain,
  CroChain,
  TerraChain,
  JunoChain,
  AkashChain,
  CantoChain,
  IrisChain,
  CelestiaChain,
} from '@types';

const { cosmos } = staticConfig;

export const getChainInfo = (chain: CosmosChain): CosmosChainInfo => {
  switch (chain) {
    case CosmosHubChain.mainnet:
      return cosmos.cosmosHub.chainInfo.mainnet;
    case CosmosHubChain.testnet:
      return cosmos.cosmosHub.chainInfo.testnet;
    case TerraChain.mainnet:
      return cosmos.terra.chainInfo.mainnet;
    case TerraChain.testnet:
      return cosmos.terra.chainInfo.testnet;
    case JunoChain.mainnet:
      return cosmos.juno.chainInfo.mainnet;
    case JunoChain.testnet:
      return cosmos.juno.chainInfo.testnet;
    case AkashChain.mainnet:
      return cosmos.akash.chainInfo.mainnet;
    case AkashChain.testnet:
      return cosmos.akash.chainInfo.testnet;
    case CantoChain.mainnet:
      return cosmos.canto.chainInfo.mainnet;
    case CantoChain.testnet:
      return cosmos.canto.chainInfo.testnet;
    case IrisChain.mainnet:
      return cosmos.iris.chainInfo.mainnet;
    case IrisChain.testnet:
      return cosmos.iris.chainInfo.testnet;
    case CelestiaChain.mainnet:
      return cosmos.celestia.chainInfo.mainnet;
    case CroChain.mainnet:
      return cosmos.cryptoOrg.chainInfo.mainnet;
    case CroChain.testnet4:
      return cosmos.cryptoOrg.chainInfo.testnet4;
    default:
      throw new UnsupportedError(chain);
  }
};
